import React, { useState } from 'react';
import { HelpModule } from '../../help/types';

interface HelpModuleBodyProps {
  module: HelpModule;
}

/**
 * Egy modul leírása: mire való, lépések, tippek, elemek és - ha már készült -
 * a bemutató GIF. A tanuló mód sávja és a Súgó oldal is ezt mutatja.
 */
const HelpModuleBody: React.FC<HelpModuleBodyProps> = ({ module }) => {
  // Ha a GIF fájl még nincs a helyén, inkább semmi, mint egy törött kép
  const [gifFailed, setGifFailed] = useState(false);
  const showGif = module.gif && !gifFailed;

  return (
    <div className={showGif ? 'grid gap-4 md:grid-cols-[minmax(0,1fr)_minmax(0,22rem)]' : ''}>
      <div className="min-w-0 space-y-3 text-sm text-gray-700">
        <p>{module.summary}</p>

        <div>
          <h4 className="font-semibold text-gray-900">Hogyan használd</h4>
          <ol className="mt-1 list-decimal space-y-1 pl-5">
            {module.steps.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
        </div>

        {module.items && module.items.length > 0 && (
          <div>
            <h4 className="font-semibold text-gray-900">Gombok és mezők</h4>
            <dl className="mt-1 space-y-1">
              {module.items.map((item) => (
                <div key={item.id}>
                  <dt className="inline font-medium text-gray-900">{item.label}: </dt>
                  <dd className="inline">{item.text}</dd>
                </div>
              ))}
            </dl>
          </div>
        )}

        {module.tips && module.tips.length > 0 && (
          <div>
            <h4 className="font-semibold text-gray-900">Jó tudni</h4>
            <ul className="mt-1 list-disc space-y-1 pl-5">
              {module.tips.map((tip) => (
                <li key={tip}>{tip}</li>
              ))}
            </ul>
          </div>
        )}
      </div>

      {showGif && (
        <figure className="min-w-0">
          {/* Kicsiben csak ízelítő - új lapon teljes méretben nézhető */}
          <a href={module.gif} target="_blank" rel="noreferrer" title="Megnyitás teljes méretben">
            <img
              src={module.gif}
              alt={`Bemutató: ${module.title}`}
              loading="lazy"
              onError={() => setGifFailed(true)}
              className="w-full cursor-zoom-in rounded-lg border border-gray-200 bg-white shadow-sm"
            />
          </a>
          <figcaption className="mt-1 text-xs text-gray-500">Rövid bemutató - kattints a nagyításhoz</figcaption>
        </figure>
      )}
    </div>
  );
};

export default HelpModuleBody;
